import { PanelLeftClose } from 'lucide-react';
import { ToolbarIconButton } from '../shared/ToolbarIconButton';

interface CollapseSidebarButtonProps {
  onClick: () => void;
}

export function CollapseSidebarButton({ onClick }: CollapseSidebarButtonProps) {
  return (
    <ToolbarIconButton
      icon={PanelLeftClose}
      label="Collapse sidebar"
      className="text-muted-foreground"
      onClick={onClick}
    />
  );
}
